import React from "react";
import moment from "moment-timezone";

// Mirrors EmailLog::STATUSES on the backend.
export const STATUS_STYLES = {
  pending: { label: "Pending", color: "#f57c00", background: "#fff3e0" },
  accepted: { label: "Accepted", color: "#1565c0", background: "#e3f2fd" },
  delivered: { label: "Delivered", color: "#2e7d32", background: "#e8f5e9" },
  failed: { label: "Failed", color: "#c62828", background: "#ffebee" },
  bounced: { label: "Bounced", color: "#ad1457", background: "#fce4ec" },
  complained: { label: "Complained", color: "#6a1b9a", background: "#f3e5f5" },
};

// Mirrors EmailLog::RETRYABLE_STATUSES on the backend.
export const RETRYABLE_STATUSES = ["failed", "bounced"];

export function StatusBadge(props) {
  var style = STATUS_STYLES[props.status] || { label: props.status, color: "#555", background: "#eee" };
  return (
    <span
      style={{
        color: style.color,
        background: style.background,
        borderRadius: 12,
        padding: "2px 10px",
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {style.label}
    </span>
  );
}

export function formatInTimezone(dateStr, tz) {
  if (!dateStr) return "-";
  var m = moment.utc(dateStr);
  if (tz) {
    m = m.tz(tz);
  }
  return m.format("MMM D, YYYY HH:mm");
}

// "App\Mail\AppointmentBooked" -> "AppointmentBooked"
export function shortClassName(className) {
  if (!className) return "-";
  var parts = className.split("\\");
  return parts[parts.length - 1];
}

export function truncate(text, length) {
  if (!text) return "-";
  return text.length > length ? text.slice(0, length) + "..." : text;
}
